import { useCallback } from 'react'
import { useAppDispatch } from '@/state'
import { TransactionsActions } from '@/state/transactions/slices/index.slices'

import {
  ContributionsFreePlaysPayload,
  ContributionsLibraryColumnProps,
  ContributionsFreePlays,
  ContributionsFilters,
} from '@/state/transactions/models'
import { getAllFreePlayContributionsThunk } from '@/state/transactions/thunks/get-freeplay-contribution.thunk'
import { TableHeadCellPropsType } from '@/state/ui/global/models'

import { exportXlsxFile } from '@/utils'

export const useContributionsActions = () => {
  const dispatch = useAppDispatch()

  const getAllFreePlayContributions = async (
    filters: ContributionsFreePlaysPayload,
    headCells?: TableHeadCellPropsType<ContributionsLibraryColumnProps>[],
    fileName?: string,
    getFormattedRow?: (
      row: ContributionsFreePlays,
    ) => ContributionsLibraryColumnProps,
  ) => {
    const resultAction = await dispatch(
      getAllFreePlayContributionsThunk({
        ...filters,
      }),
    )

    if (
      getFormattedRow &&
      headCells &&
      getAllFreePlayContributionsThunk.fulfilled.match(resultAction)
    ) {
      exportXlsxFile(
        headCells,
        resultAction.payload.docs.map((item) => getFormattedRow(item)),
        fileName,
      )
    }
  }

  const setContributionsFilters = useCallback(
    (filters: ContributionsFilters) =>
      dispatch(TransactionsActions.setContributionsFiltersAction(filters)),
    [dispatch],
  )

  const cleanContributions = useCallback(
    () => dispatch(TransactionsActions.cleanContributionsAction()),
    [dispatch],
  )

  return {
    getAllFreePlayContributions,
    setContributionsFilters,
    cleanContributions,
  }
}
